// Copyright 2019 Sorama B.V.

export abstract class ILocalApi {
    public readonly defaultBaseAddress: string;

    public readonly baseAddress: Promise<string>;
    public readonly baseUri: Promise<string>;
    public readonly common: Promise<string>;
    public readonly frontEnds: Promise<string>;
    public readonly captureDevices: Promise<string>;
    public readonly stream: Promise<string>;
    public readonly storage: Promise<string>;
    public readonly videoFile: Promise<string>;
    public readonly farfield: Promise<string>;
    public readonly soundProcessing: Promise<string>;
    public readonly analysis: Promise<string>;
    public readonly motion: Promise<string>;
    public readonly camIV64: Promise<string>;
}
